<!-- 年度各月数据同环比 -->
<template>
  <div class="proportion">
    <div id="bar"></div>
    <div class="bar-info">
      <div class="bar-info-left">
        <div class="first">
          <div class="first-top">{{chartData.years[0]}}年{{chartData.months[0]}}月{{useSelected == 0 ? '资金使用率' : '补贴兑付率'}}</div>
          <div class="first-bottom">{{chartData.dataList[0]}}%</div>
        </div>
        <div class="second">
          <div class="second-top">{{chartData.years[1]}}年{{chartData.months[1]}}月{{useSelected == 0 ? '资金使用率' : '补贴兑付率'}}</div>
          <div class="second-bottom">{{chartData.dataList[1]}}%</div>
        </div>
        <div class="third">
          <div class="third-top">{{useSelected == 0 ? '使用率' : '兑付率'}}{{rightTopSwitch == 1 ? '同比' : '环比'}}<span :style="{'color': chartData.ratio >=0 ? 'rgba(95, 255, 151, 1)' : '#ffae0d'}">{{chartData.ratio >=0 ? '增长' : '减少'}}</span></div>
          <div class="third-bottom">
            <span class="icon" :class="chartData.ratio < 0 ? 'rotate' : ''"></span>
            {{chartData.ratio}}%
          </div>
        </div>
      </div>
      <div class="bar-info-right">
        <div class="btn" @click="switchClcik(1)" :class="rightTopSwitch == 1?'active':''">同比</div>
        <div class="btn" @click="switchClcik(2)" :class="rightTopSwitch == 2?'active':''">环比</div>
      </div>
    </div>
  </div>
</template>


<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
import { parseTime } from "@/utils/index";
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    // 使用率0、兑付率1
    useSelected: {
      type: Number,
      default: 0,
    },
    // 选择月份
    monthSelected: {
      type: Number,
      default: 0,
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          yearAndMonth: ['2022.03', '2023.03'],
          years: [2022, 2023],
          months: ['03', '03'],
          dataList: [100, 200],
          ratio: '10%'
        }
      }
    }
  },
  data() {
    return {
      chart: null,
      unit: '%',
      // 同比1、环比2
      rightTopSwitch: 1,
      // 立体柱状图颜色 [[黄色、绿色]]
      colorArr: [['rgba(125, 85, 6, ', 'rgba(217, 152, 24, ','rgba(92, 62, 4, ','rgba(117, 79, 4, '], ['rgba(7, 125, 68, ', 'rgba(25, 218, 125, ', 'rgba(4, 93, 50, ', 'rgba(3, 117, 62, ']],
      options: {
        // tooltip: {
        //   position: function (pos, params, dom, rect, size) {
        //       // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
  
        //       return [pos[0] - 20, '10'];;
        //   },
        //   trigger: "axis",
        //   borderColor: 'rgba(10, 69, 31, 0.8)',
        //   backgroundColor: 'rgba(10, 69, 31, 0.8)',
        //   axisPointer: {
        //     type: "line",
        //     lineStyle: {
        //       type: 'dashed',
        //       width: 1,
        //     },
        //     label: {
        //       color: '#ffffff',
        //       backgroundColor: "rgba(10, 69, 31, 0.8)",
        //     },
        //     axis: 'y'
        //   },
        //   formatter(params) {
        //     let dom = '';
        //     [params[0]].map(v=>{
        //       dom+= `
        //       <div style="background: rgba(0, 81, 28, 0.5);border-radius: 4px;font-size:12px;color: #95FFBA;font-weight:400;line-height:1;">${v.axisValueLabel}</div>`
        //     });
        //     return `<div>${dom}</div>`;
        //   }
        // },
        legend: {
          show: false,
          orient: "horizontal",
          x: "right",
          y: "10",
          itemWidth: 10,
          itemHeight: 10,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 255, 169, 1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 255, 169, 0.3)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          textStyle: {
            color: "#FFFFFF",
            fontSize: "12",
          },
        },
        grid: {
          right: "10%",
          left: "20%",
          top: "20%",
          bottom: "9%"
        },
        xAxis: {
          type: "category",
          axisTick: {
            //y轴刻度线
            show: false,
          },
          offset: 8,
          axisLabel: {
            show: false,
            interval: 0,
            color: '#BABBBD',
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          data: [],
        },
        yAxis: {
          minInterval: 1,
          name: `（${this.unit || '%'}）`,
          type: "value",
          nameTextStyle: {
            color: 'rgba(186, 187, 189, 1)',
            fontSize: 12,
            align: 'right',
            padding: [0, 2, 5, 0]
          },
          axisLabel: {
            interval: 0,
            color: '#FFFFFF',
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFFFFF",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(88, 252, 146, 0.17)",
              type: 'dashed'
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    '$route': {
      deep: true,
      handler(newVal, oldVal) {
        this.rightTopSwitch = 1;
      }
    },
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  created() {},
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    // 同比1、环比切换2
    switchClcik(type) {
      if(type == 1) {
        this.rightTopSwitch = 1;
      }else {
        this.rightTopSwitch = 2;
      }
      this.$emit('switchClcik', this.rightTopSwitch);
    },
    setChartData() {
      this.options.yAxis.name = `（${this.unit || '%'}）`;
      let series = [];
      let that = this;
      let backgroundColor = '';
      if (this.chartData.dataList && this.chartData.dataList.length > 0) {
        // 为了实现立体效果，把两个柱子并在一起
        series.push({
          name: 'leftBar',
          type: "bar",
          barGap: 0,
          barWidth: "10",
          label: {
            show: true,
            position: "top",
            align: 'center',
            fontSize: 12,
            formatter(v) {
              return `{nameStyle${v.dataIndex}|${v.name}}\n{valueStyle${v.dataIndex}|${v.value}%}`; // 使用定义好的 rich 样式
            },
            rich: {
              nameStyle0: {
                width: 40,
                borderRadius: [4,4,0,0],
                padding: [0, 6, 4, 6],
                color: '#C49C4B',
                backgroundColor: 'rgba(82, 54, 0, 0.5)',
              },
              valueStyle0: {
                width: 40,
                borderRadius: [0,0,4,4],
                padding: [4, 6, 4 ,6],
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(82, 54, 0, 0.5)',
              },
              nameStyle1: {
                width: 40,
                borderRadius: [4,4,0,0],
                padding: [0, 6, 4, 6],
                color: '#4BC476',
                backgroundColor: 'rgba(0, 81, 28, 0.5)',
              },
              valueStyle1: {
                width: 40,
                padding: [4, 6, 4 ,6],
                borderRadius: [0,0,4,4],
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(0, 81, 28, 0.5)',
              }
            }
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return  new echarts.graphic.LinearGradient(0,0,0,1, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[params.dataIndex][1] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[params.dataIndex][0] + '1)',
                    },
                  ]
                );
              }
            },
          },
          data: this.chartData.dataList,
          z: 5,
          zlevel: 10,
        });
        series.push({
          name: 'rightBar',
          type: "bar",
          barWidth: "10",
          barGap: 0,
          label: {
            show: false,
            position: "insideLeft",
            formatter(v) {
              if (v.value) {
                return "";
              } else {
                return v.value;
              }
            },
          },
          itemStyle: {
            normal: {
              color: function(params) {
                return new echarts.graphic.LinearGradient(0,0,0,1, 
                  //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: that.colorArr[params.dataIndex][3] + '1)',
                    },
                    {
                      offset: 1,
                      color: that.colorArr[params.dataIndex][2] + '1)',
                    },
                  ]
                );
              }
            },
          },
          data: this.chartData.dataList,
          z: 5,
          zlevel: 10,
        });
        series.push(
          {
              // 最下面菱形
              data: this.chartData.dataList,
              type: 'pictorialBar',
              symbol: 'diamond',
              symbolSize: [20, 10],
              symbolPosition: 'end',
              symbolOffset: [0, -5],
              itemStyle: {
                normal: {
                  color: function(params) {
                    return that.colorArr[params.dataIndex][1] + '1)'
                  },
                },
              },
              z: 6,
              zlevel: 10,
            }
        );

        this.options.xAxis.data = this.chartData.yearAndMonth;
        this.options.series = series;
        this.chart.setOption(this.options);
      } else {
        this.options.xAxis.data = [];
        this.options.series = [];
        this.chart.setOption(this.options,true); // 设置为true的话，就是notMerge，不合并,false的话，就Merge，之前的东西还保留~
      }

    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById('bar'));
      }
      this.setChartData();
    },
  },
};
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.proportion {
  display: flex;
  height: 100%;
  width: 100%;
  margin-left: vw(10);
  #bar {
    width: vw(190);
    height: 100%;
  }
  .bar-info {
    flex: 1;
    display: flex;
    justify-content: space-between;
    font-family: Microsoft YaHei;
    .bar-info-left {
      .first {
        .first-top {
          font-size: fontSize(14);
          color: #FFFFFF;
        }
        .first-bottom {
          font-size: fontSize(20);
          color: #FFAE0D;
        }
      }
      .first {
        margin-top: vh(10);
        .first-top {
          font-size: fontSize(14);
          color: #FFFFFF;
        }
        .first-bottom {
          font-size: fontSize(20);
          color: #FFAE0D;
        }
      }
      .second {
        margin-top: vh(19);
        .second-top {
          font-size: fontSize(14);
          color: #FFFFFF;
        }
        .second-bottom {
          font-size: fontSize(20);
          color: #5FFF97;
        }
      }
      .third {
        margin-top: vh(16);
        .third-top {
          font-size: fontSize(14);
          color: #FFFFFF;
        }
        .third-bottom {
          font-size: fontSize(14);
          color: #FFFFFF;
          color: #ffffff;
          .icon {
            display: inline-block;
            width: vw(13);
            height: vh(15);
            background: url("../../../../assets/images/work/icon_arrow_top.png") no-repeat;
            background-size: 100% 100%;
            &.rotate {
              background: url("../../../../assets/images/work/icon_arrow_down.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    .bar-info-right {
      margin-right: vw(22);
      font-size: fontSize(14);
      color: #92E8B0;
      .btn {
        margin-top: vh(12);
        width: vw(26);
        height: vh(78);
        background: url("../../../../assets/images/governmentAffairs/purchaseAllowance/btn_tab.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        text-align: center;
        cursor: pointer;
        &.active {
          padding-top: vh(4);
          font-size: fontSize(14);
          color: #FFFFFF;
          background: url("../../../../assets/images/governmentAffairs/purchaseAllowance/btn_tab_c.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}



</style>
